import * as faceapi from 'face-api.js';


export async function loadModels() {
    await Promise.all([
      faceapi.nets.tinyFaceDetector.loadFromUri('/models/ssd_mobilenetv1'),
      faceapi.nets.faceLandmark68Net.loadFromUri('/models/face_landmark_68'),
      faceapi.nets.faceRecognitionNet.loadFromUri('/models/face_recognition'),
    ]);
  }
  